import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Document3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25735 2.75736C2.5 4.51473 2.5 7.34314 2.5 13V19C2.5 24.6568 2.5 27.4853 4.25735 29.2426C6.01472 31 8.84314 31 14.5 31H17.5C23.1568 31 25.9853 31 27.7426 29.2426C29.5 27.4853 29.5 24.6568 29.5 19V13C29.5 7.34314 29.5 4.51473 27.7426 2.75736C25.9853 1 23.1568 1 17.5 1H14.5C8.84314 1 6.01472 1 4.25735 2.75736ZM10 11.875C9.37869 11.875 8.875 12.3787 8.875 13C8.875 13.6213 9.37869 14.125 10 14.125H22C22.6213 14.125 23.125 13.6213 23.125 13C23.125 12.3787 22.6213 11.875 22 11.875H10ZM10 17.875C9.37869 17.875 8.875 18.3787 8.875 19C8.875 19.6213 9.37869 20.125 10 20.125H17.5C18.1213 20.125 18.625 19.6213 18.625 19C18.625 18.3787 18.1213 17.875 17.5 17.875H10Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
